import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import classes from './layout.module.css';
import { makeStyles } from 'utils';

const styles = makeStyles(classes);

function Page({ title, fitScreen, children, size }) {
    return (
        <div className={styles('page', fitScreen ? 'page--fit-screen' : null)}>
            <div className={classes['page__title']}>
                <Typography variant={size === 'small' ? 'h6' : 'h2'} align="center">
                    {title}
                </Typography>
            </div>
            {children}
        </div>
    )
}

Page.propTypes = {
    fitScreen: PropTypes.bool,
    title: PropTypes.string.isRequired
};

export default Page;